import $ from "jquery";
import { CursorPluginBase } from "@core/graphs/plugins/Dh-plugin-cursor-base";
import { i18nGlobal } from "@common/js/utils";

export class SideFrequencyCursorPlugin extends CursorPluginBase {
    constructor(mode) {
        super(mode);
        this.Title = i18nGlobal('core.sideFrequencyCursor');
        this.Cursors = new Map();
        this.CursorDatas = new Map();
        this.CenterCursor;
        this.CenterCursorData;
        this.SideCursorCount = 1;
    }
    CreatePlugin() {
        this.InitSvgEvent();
    }
    SetCursorCount(count) {
        this.SideCursorCount = count;
        this.ClearCursor();
        this.CreateCenterCursoe();
        this.CreateSideCursor(count);
    }
    ClearCursor() {
        if (this.CenterCursor) {
            this.CenterCursor.Remove();
            this.CenterCursor = null;
        }

        this.CenterCursorData = null;
        for (const cursor of this.Cursors.values()) {
            cursor.left.Remove();
            cursor.right.Remove();
        }
        this.Cursors.clear();
        this.CursorDatas.clear();
    }
    CreateCenterCursoe() {
        if (!this.CenterCursor) {
            let opt = {
                Key: 0,
                Name: "Center",
                Checked: true,
                Color: "black",
                X: 0.5,
                Y: 0,
            };
            let rect = this.Owner.Information.ShapeContainerRect;
            let pos = rect.Width * opt.X;
            this.CenterCursor = new FlagCursorElement(this, rect.Height, opt.Color, "1", { X: rect.Left, Y: rect.Top }, "I" + opt.Name);
            $(this.Owner.PluginContainer).append(this.CenterCursor.DOM);
            this.CenterCursorData = opt;
            this.CenterCursor.UpdatePosition(pos);
        }
    }
    CreateSideCursor(count) {
        this.Cursors = new Map();
        this.CursorDatas = new Map();
        for (let i = 0; i < count; i++) {
            let rect = this.Owner.Information.ShapeContainerRect;
            let pos = rect.Width * this.CenterCursorData.X;
            let lOpt = {
                Key: i,
                Name: i,
                Checked: true,
                Color: "black",
                X: (pos - 50 * (i + 1)) / rect.Width,
                Y: 0,
            };
            let rOpt = {
                Key: i,
                Name: i,
                Checked: true,
                Color: "black",
                X: (pos + 50 * (i + 1)) / rect.Width,
                Y: 0,
            };
            let leftCursor = new FlagCursorElement(this, rect.Height, lOpt.Color, "1", { X: rect.Left, Y: rect.Top }, "L" + lOpt.Name);
            let rightCursor = new FlagCursorElement(this, rect.Height, rOpt.Color, "1", { X: rect.Left, Y: rect.Top }, "R" + rOpt.Name);
            $(this.Owner.PluginContainer).append(leftCursor.DOM);
            $(this.Owner.PluginContainer).append(rightCursor.DOM);
            this.Cursors.set(i, { left: leftCursor, right: rightCursor });
            this.CursorDatas.set(i, { left: lOpt, right: rOpt });
            leftCursor.UpdatePosition(pos - 50 * (i + 1));
            rightCursor.UpdatePosition(pos + 50 * (i + 1));
        }
    }
    RemoveCursor(option) {
        if (this.Cursors.has(option.Key)) {
            let cursor = this.Cursors.get(option.Key);
            cursor.Remove();
            this.Cursors.delete(option.Key);
        }
        this.CursorDatas.delete(option.Key);
    }
    OnSizeChanged() {
        let rect = this.Owner.Information.ShapeContainerRect;
        if (this.CenterCursor) {
            this.CenterCursor.Remove();

            let pos = rect.Width * this.CenterCursorData.X;
            this.CenterCursor = new FlagCursorElement(this, rect.Height, this.CenterCursorData.Color, "1", { X: rect.Left, Y: rect.Top }, "I" + this.CenterCursorData.Name);
            $(this.Owner.PluginContainer).append(this.CenterCursor.DOM);
            this.CenterCursor.UpdatePosition(pos);
        }
        for (const cursor of this.Cursors.values()) {
            cursor.left.Remove();
            cursor.right.Remove();
        }
        for (const key of this.CursorDatas.keys()) {
            let cursorData = this.CursorDatas.get(key);
            let cursor = this.Cursors.get(key);

            let leftCursor = new FlagCursorElement(this, rect.Height, cursorData.left.Color, "1", { X: rect.Left, Y: rect.Top }, "L" + cursorData.left.Name);
            let rightCursor = new FlagCursorElement(this, rect.Height, cursorData.right.Color, "1", { X: rect.Left, Y: rect.Top }, "R" + cursorData.right.Name);
            $(this.Owner.PluginContainer).append(leftCursor.DOM);
            $(this.Owner.PluginContainer).append(rightCursor.DOM);
            cursor.left = leftCursor;
            cursor.right = rightCursor;
            leftCursor.UpdatePosition(cursorData.left.X * rect.Width);
            rightCursor.UpdatePosition(cursorData.right.X * rect.Width);
        }
    }
    OnMouseMove(e) {
        if (!super.OnMouseMove(e)) return false;
        if (e.which !== 1) return false;
        if (!this.CenterCursor) return false;
        if (!this.CenterCursorData) return false;
        if (this.Cursors.size == 0) return false;
        if (this.CursorDatas.size == 0) return false;
        let rect = this.Owner.Information.ShapeContainerRect;
        let pos = e.offsetX - rect.Left;
        let sender = this;
        if (this.CenterCursor.IsMouseDown) {
            let translateLenth = pos - this.CenterCursorData.X * rect.Width;
            this.CenterCursorData.X = pos / rect.Width;
            this.CenterCursor.UpdatePosition(pos);
            $.each(this.Cursors.keys(), function () {
                let cursorItem = sender.Cursors.get(this);
                let cursorDataItem = sender.CursorDatas.get(this);

                let leftPos = cursorDataItem.left.X * rect.Width + translateLenth;
                cursorDataItem.left.X = leftPos / rect.Width;
                cursorItem.left.UpdatePosition(leftPos);

                let rightPos = cursorDataItem.right.X * rect.Width + translateLenth;
                cursorDataItem.right.X = rightPos / rect.Width;
                cursorItem.right.UpdatePosition(rightPos);
            });
        } else {
            $.each(this.Cursors.keys(), function () {
                let cursorItem = sender.Cursors.get(this);
                let cursorDataItem = sender.CursorDatas.get(this);
                if (cursorItem.left.IsMouseDown) {
                    let translateLenth = pos - cursorDataItem.left.X * rect.Width;
                    cursorDataItem.left.X = pos / rect.Width;
                    cursorItem.left.UpdatePosition(pos);

                    let rightPos = cursorDataItem.right.X * rect.Width - translateLenth;
                    cursorDataItem.right.X = rightPos / rect.Width;
                    cursorItem.right.UpdatePosition(rightPos);
                }
                if (cursorItem.right.IsMouseDown) {
                    let translateLenth = pos - cursorDataItem.right.X * rect.Width;
                    cursorDataItem.right.X = pos / rect.Width;
                    cursorItem.right.UpdatePosition(pos);

                    let leftPos = cursorDataItem.left.X * rect.Width - translateLenth;
                    cursorDataItem.left.X = leftPos / rect.Width;
                    cursorItem.left.UpdatePosition(leftPos);
                }
            });
        }
        return true;
    }
    OnMouseUp(e) {
        if (!super.OnMouseUp(e)) return false;
        if (e.which !== 1) return false;
        let sender = this;
        if (!this.IsMouseDown) return;
        let rect = this.Owner.Information.ShapeContainerRect;
        let pos = e.offsetX - rect.Left;
        if (this.CenterCursor.IsMouseDown) {
            let translateLenth = pos - this.CenterCursorData.X * rect.Width;
            this.CenterCursorData.X = pos / rect.Width;
            cursor.UpdatePosition(pos);
            $.each(this.Cursors.keys(), function () {
                let cursorItem = sender.Cursors.get(this);
                let cursorDataItem = sender.CursorDatas.get(this);

                let leftPos = cursorDataItem.left.X * rect.Width + translateLenth;
                cursorDataItem.left.X = leftPos / rect.Width;
                cursorItem.left.UpdatePosition(leftPos);

                let rightPos = cursorDataItem.right.X * rect.Width + translateLenth;
                cursorDataItem.right.X = rightPos / rect.Width;
                cursorItem.right.UpdatePosition(rightPos);
            });
        } else {
            $.each(this.Cursors.keys(), function () {
                let cursorItem = sender.Cursors.get(this);
                let cursorDataItem = sender.CursorDatas.get(this);
                if (cursorItem.left.IsMouseDown) {
                    let translateLenth = pos - cursorDataItem.left.X * rect.Width;
                    cursorDataItem.left.X = pos / rect.Width;
                    cursorItem.left.UpdatePosition(pos);

                    let rightPos = cursorDataItem.right.X * rect.Width - translateLenth;
                    cursorDataItem.right.X = rightPos / rect.Width;
                    cursorItem.right.UpdatePosition(rightPos);
                }
                if (cursorItem.right.IsMouseDown) {
                    let translateLenth = pos - cursorDataItem.right.X * rect.Width;
                    cursorDataItem.right.X = pos / rect.Width;
                    cursorItem.right.UpdatePosition(pos);

                    let leftPos = cursorDataItem.left.X * rect.Width - translateLenth;
                    cursorDataItem.left.X = leftPos / rect.Width;
                    cursorItem.left.UpdatePosition(leftPos);
                }
            });
        }
        return true;
    }
    GetPosition() {
        let result = {
            PluginType: this.Entity.Type,
            Cursors: this.CursorDatas.getValues(),
        };
        return result;
    }
    Close() {
        super.Close();
        if (this.CenterCursor) {
            this.CenterCursor.Remove();
            this.CenterCursor = null;
        }

        this.CenterCursorData = null;
        for (let cursor of this.Cursors.values()) {
            cursor.left.Remove();
            cursor.right.Remove();
        }
        this.Cursors.clear();
        this.CursorDatas.clear();
    }
}
